<template>
  <div>
    <br />
    <h2 class="ViewHeading">Super Users</h2>
    <div>
      <b-row
        ><b-col>
          <h4>{{ this.selectedlocation }}</h4>
        </b-col></b-row
      >
      <b-card>
        <b-tabs>
          
          <b-tab active>
            <template #title> Users <BIconPeople></BIconPeople> </template>
            <b-card>
              <Users> </Users>
            </b-card>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Companies <BIconBriefcase></BIconBriefcase>
            </template>
            <b-card>
              <CompanyAdmin></CompanyAdmin>
            </b-card>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Locations <BIconBuilding></BIconBuilding>
            </template>
            <b-card>
              <LocationAdmin></LocationAdmin>
            </b-card>
          </b-tab>
          <b-tab lazy>
            <template #title>
              Devices <BIconViewStacked></BIconViewStacked>
            </template>
            <b-card>
              <DeviceAdmin> </DeviceAdmin>
            </b-card>
          </b-tab>
          <b-tab v-if="UserAccess == 'Batteries Need Done'" lazy>
            <template #title>
              Battery <BIconBatteryHalf/>
            </template>
            <b-card>
              <Battery />
            </b-card>
          </b-tab>
          <b-tab v-if="UserAccess == 'Reports Need Done'" lazy>
            <template #title>
              Reports <BIconFileEarmarkSpreadsheet/>
            </template>
            <b-card>
              Super User Reports Component Here
            </b-card>
          </b-tab>
          <b-tab lazy v-if="UserAccess == 'Servicing link here'">
            <template #title> Service <BIconInbox></BIconInbox> </template>
            <b-card>
              <SupportService></SupportService>
            </b-card>
          </b-tab>
        </b-tabs>
      </b-card>
      <b-row
        ><b-col><br /></b-col
      ></b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconPeople,
  BIconBuilding,
  BIconBriefcase,
  BIconViewStacked,
  BIconFileEarmarkSpreadsheet,
  BIconInbox,
  BIconBatteryHalf
} from "bootstrap-vue";
import LocationAdmin from "../components/LocationAdminSUP.vue";
import CompanyAdmin from "../components/CompanyAdminSUP.vue";
import SupportService from "../views/SupportOverview.vue";
import Users from "../components/OtherUserAdmin.vue";
import DeviceAdmin from "../views/DeviceAdminSUP.vue";
import Battery from "../components/BatteryStatus.vue"

export default {
  computed: {},
  components: {
    BIconPeople,
    BIconBuilding,
    BIconBriefcase,
    BIconViewStacked,
    BIconFileEarmarkSpreadsheet,
    LocationAdmin,
    CompanyAdmin,
    SupportService,
    BIconInbox,
    BIconBatteryHalf,
    Users,
    DeviceAdmin,
    Battery
  },

  data() {
    return {
      file: "",
      DeviceID: "123456789",
      Folder: "attachments",
      items: [],
      UserHeaders: [],
      response: null,
      ArrTest: [],
      perPage: 5,
      currentPage: 1,
      rowDblClickHandler: "",
      modal: false,
      item0: "",
      item1: "",
      item2: "",
      item3: "",
      item4: "",
      showOverlay: false,
      duplicatefile: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      UserProfile: localStorage.getItem("profileportal"),
      UserAccess: localStorage.getItem("accessGroup"),
    };
  },

  beforeMount() {},

  mounted() {
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/attachments";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "LoadAll",
      RequestVariable: this.DeviceID,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        response;
        this.testing = response.data.field_names;
        this.items = response.data.Values;
        for (let i = 0; i < this.testing.length; i++) {
          var QuoteStr = "" + i + "";
          this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
        }
        this.UserHeaders = this.ArrTest;
        this.UserHeaders.push("Action");
        this.ArrTest = [];
      });
  },

  methods: {
    getUserInitials() {
      this.userInitials = localStorage.getItem("UserInitials");
      return this.userInitials;
    },
    userfullname() {
      this.userfullname = localStorage.getItem("fullname");
      return this.userfullname;
    },
    handleFileUpload() {
      this.file = event.target.files[0];
    },
    submitFile() {
      this.isExist();
      if (this.file == "") {
        alert("Please select a file to upload");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.file.size > 2000000) {
        alert("file selected is too large, maximum file size is 2mb");
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      }
      if (this.duplicatefile == true) {
        alert(
          "File with this name already exists, uploading will overwrite current file. Please delete existing file or change name of file to be uploaded."
        );
        this.file = "";
        document.getElementById("file-upload").value = null;
        return;
      } else {
        this.uploadFile(this.file);
      }
    },

    isExist: function() {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i][3] == this.file.name) {
          this.duplicatefile = true;
          return true;
        }
      }
      this.duplicatefile = false;
      return false;
    },

    cancelChooseFile() {
      alert("File Upload Cancelled");
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    //async onRemoveFile(event) {
    //let url = "attachments" + '/' + event.file.name // event.file.name has only the name after the slash / so the actual filename
    //const res = await deleteObjectByKey(url)
    // if (
    //  res.$response.httpResponse.statusCode >= 200 &&
    //  res.$response.httpResponse.statusCode < 300
    // ){
    // here remove data from database too
    //  }
    // },

    submitFileToDB(FileSave, FileLocation) {
      this.SubmitUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Create",
        RequestVariable: "",
        DataDict: [
          {
            DeviceID: this.DeviceID,
            FileName: FileSave,
            FileURL: FileLocation,
            UploaderURN: this.SubmitUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          response;
          this.refreshTable();
        });
    },

    showActionModal(var0, var1, var2, var3, var4) {
      this.item0 = var0;
      this.item1 = var1;
      this.item2 = var2;
      this.item3 = var3;
      this.item4 = var4;
      this.$refs["DeviceAttachModal"].show(
        this.item0,
        this.item1,
        this.item2,
        this.item3,
        this.item4
      );
    },

    resetValue() {
      this.file = "";
      document.getElementById("file-upload").value = null;
    },

    DeleteAttachment(delvar1) {
      this.DeleteUserURN = this.$UserURN;
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;

      this.LookUpRequest = {
        RequestType: "Delete",
        RequestVariable: delvar1,
        DataDict: [
          {
            ClearedURN: this.DeleteUserURN,
          },
        ],
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.$refs["DeviceAttachModal"].hide();
          this.refreshTable();
        });
    },
    resetmodal() {
      this.$refs["DeviceAttachModal"].hide();
    },
    refreshTable() {
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/attachments";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "LoadAll",
        RequestVariable: this.DeviceID,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          this.testing = response.data.field_names;
          this.items = response.data.Values;
          for (let i = 0; i < this.testing.length; i++) {
            var QuoteStr = "" + i + "";
            this.ArrTest.push({ key: QuoteStr, label: this.testing[i] });
          }
          this.UserHeaders = this.ArrTest;
          this.UserHeaders.push("Action");
          this.ArrTest = [];
        });
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid cadetblue;
  border-radius: 5px;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
  color: cadetblue;
}

#Table {
  margin: auto;
  text-align: center;
}

#cancel-label {
  color: white;
  font-size: large;
}

.Upload label {
  font-size: 15px;
}

.modal {
  text-align: center;
}
</style>
